<template>
	<section>
		<div v-if="items.top_slider.type == 'image'" class="iv2-hero position-relative overflow-hidden">
			<swiper :options="swiperOption">
				<swiper-slide v-for="media in items.top_slider.image_option" :key="media.id">
					<img
						:src="media.src"
						class="iv2-hero-image"
						alt="cover"
						data-swiper-parallax-scale="1.05"
						data-swiper-parallax-duration="1500"
					/>
					<div
						class="iv2-hero--color position-absolute"
						:style="{ 'background-color': color, opacity: opacity }"
					></div>
					<div class="iv2-hero-text position-absolute text-center">
						<div class="row">
							<div class="col-md-12 ml-auto mr-auto text-center">
								<h2 v-html="media.main_title" class="iv2-hero__main-title" style="font-style: italic;"></h2>
								<h4 v-html="media.sub_title" class="iv2-hero__sub-title"></h4>
							</div>
						</div>
					</div>
				</swiper-slide>
			</swiper>
		</div>
		<div v-else-if="items.top_slider.type == 'video'" class="iv2-hero position-relative overflow-hidden">
			<video class="iv2-hero-video fit-img" autoplay muted loop playsinline>
				<source :src="items.top_slider.image_option.src" type="video/mp4" />
			</video>

			<div
				class="iv2-hero--color position-absolute"
				:style="{'background-color': color,opacity: opacity,}"
			></div>
			<div class="iv2-hero-text position-absolute text-center">
				<div class="row">
					<div class="col-md-12 ml-auto mr-auto text-center">
						<h2
							v-html="items.top_slider.image_option.main_title"
							class="iv2-hero__main-title"
							style="font-weight: 400; font-style: italic;"
						></h2>
						<h4 v-html="items.top_slider.image_option.sub_title" class="iv2-hero__sub-title"></h4>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import "swiper/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
	components: {
		swiper,
		swiperSlide
	},
	name: "LayoutHero",

	props: ["items"],

	data() {
		return {
			swiperOption: {
				speed: 1000,
				effect: "fade",
				parallax: true,
				autoplay: {
					delay: 6000,
					disableOnInteraction: false
				}
			},

			color: "#000000",
			opacity: 0
		};
	}
};
</script>

<style lang="scss">
.swiper-container {
	height: 100%;
}

.iv2-hero {
	background-color: #000000;
	height: 100vh;

	.iv2-hero-image {
		margin: 0 !important;
		height: 100%;
		width: 100%;
		object-fit: cover;
	}

	.iv2-hero-video {
		margin: 0 !important;
		height: 100%;
		width: 100%;
		object-fit: cover;
	}

	.iv2-hero--color {
		top: 0;
		width: 100%;
		height: 100%;
	}

	.iv2-hero-text {
		width: 100%;
		top: 50%;
		left: 50%;
		-webkit-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%);
		margin: auto;
		color: #ffffff;
		z-index: 2;
		animation-name: fade;
		animation-duration: 4s;
		text-shadow: 0px -1px 10px #00000085;
	}
	@keyframes fade {
		0% {
			opacity: 0;
		}
		10% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}
}

/* PC */
@media (min-width: 1200px) {
	.iv2-hero {
		.iv2-hero__main-title {
			font-size: 5rem;
		}

		.iv2-hero__sub-title {
			font-size: 1.9rem;
		}
	}
}

/* TABLET or SP */
@media (max-width: 1199px) {
	.iv2-hero {
		height: calc(100vh - 64px);

		.iv2-hero-text {
			top: 50%;
			left: 50%;
			-webkit-transform: translate(-50%, -50%);
			transform: translate(-50%, -50%);
			width: 90%;
			margin: auto;
			color: #ffffff;
		}
	}
}

/* TABLET Only */
@media (min-width: 768px) and (max-width: 1199px) {
	.iv2-hero {
		.iv2-hero__main-title {
			font-size: 4rem;
		}

		.iv2-hero__sub-title {
			font-size: 1.5rem;
		}
	}
}

/* SP Only */
@media (max-width: 767px) {
	.iv2-hero {
		height: calc(100vh - 105px);

		.iv2-hero__main-title {
			font-size: 2.5rem;
		}

		.iv2-hero__sub-title {
			font-size: 1rem;
		}
	}
}
</style>
